import { Button } from "@/components/atoms/Button";
import { Paragraph } from "@/components/atoms/Paragraph";
import { Progress } from "@/components/atoms/Progress";
import { Rating } from "@/components/atoms/Rating";
import type { IApplicationRatingProps } from "@/components/molecules/ApplicationRating/types";
import { useAuthUser } from "@/hooks/common/useAuthUser";
import { useTranslations } from "@/hooks/common/useTranslations";

const ApplicationRating = ({
  rating,
  ratesCount,
  onClickWriteReview,
}: IApplicationRatingProps) => {
  const { t } = useTranslations("SingleAppPage");
  const { isLogged } = useAuthUser();
  const text = t(isLogged ? "writeReview" : "signInToReview");

  return (
    <div className="flex flex-col gap-3 basis-1/3">
      <div className="flex items-baseline gap-2">
        <Paragraph size="extraLarge" fontWeight="bold" className="text-[55px]">
          {rating}
        </Paragraph>

        <Rating readOnly style={{ maxWidth: 120 }} items={5} value={rating} />
      </div>
      <div className="flex flex-col items-[normal] gap-2">
        {ratesCount.map(({ rate, count }) => (
          <div key={rate} className="flex gap-3 items-center justify-center">
            <Paragraph size="base" fontWeight="medium" className="w-1">
              {rate}
            </Paragraph>
            <Rating readOnly style={{ maxWidth: 16 }} items={1} value={1} />
            <Progress value={count} />
            <Paragraph size="base" fontWeight="medium" className="w-1">
              {count}
            </Paragraph>
          </div>
        ))}
      </div>
      <Button>
        <Paragraph
          size="small"
          fontWeight="medium"
          onClick={onClickWriteReview}
        >
          {text}
        </Paragraph>
      </Button>
    </div>
  );
};

export default ApplicationRating;
